export default class AppleReportQuery {

    public static GetAppleReport = `query AppleReportQuery($input: ReportInput!) {
            getAppleReport(input: $input) {
                provider
                providerCountry
                SKU
                developer
                title
                version
                productTypeIdentifier
                units
                developerProceeds
                beginDate
                endDate
                customerCurrency
                countryCode
                currencyOfProceeds
                appleIdentifier
                customerPrice
                promoCode
                parentIdentifier
                subscription
                period
                category
                CMB
                device
                supportedPlatforms
                proceedsReason
                preservedPricing
                client
                orderType
            }     
        }`;
}